document.querySelectorAll('.section-whats-new .collections a').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    document.querySelectorAll('.section-whats-new .collections a').forEach(a => {
      a.className = '';
    });
    link.className = 'active';

    document.querySelectorAll('.section-whats-new [class^="collection-slug-"]').forEach(block => {
      block.style.display = 'none';
    });

    // Show the target block
    const targetSlug = this.getAttribute('data-slug');
    document.querySelectorAll('.section-whats-new [class^="collection-slug-' + targetSlug + '"]').forEach(block => {
      block.style.display = '';
    });
  });
});

document.querySelectorAll('.section-featured-collections a.collection').forEach(link => {
  link.addEventListener('mouseenter', () => {
    document.querySelectorAll('.section-featured-collections a.collection').forEach(link => link.classList.remove('active'));
    link.classList.add('active');
    var image = link.attributes['data-image'];
    link.parentElement.parentElement.parentElement.querySelector('.background').src = image.value;
    link.parentElement.querySelector('.button').href = link.href;
  });
});

document.getElementById("site-credits-trigger").addEventListener("click", function () {
  const content = document.getElementById("site-credits");
  content.style.display = content.style.display === "none" ? "block" : "none";
});

document.querySelectorAll('.section-education-content').forEach((content, contentIndex) => {
  content.style.display = 'none';
  if (contentIndex == 0) {
    content.style.display = 'block';
  }
});
document.querySelectorAll('.section-education-header a.icon').forEach((link, linkIndex) => {
  const labelText = link.querySelector('.label')?.textContent || '';
  const sanitizedHash = labelText
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')   // Replace non-alphanumeric with dash
    .replace(/^-+|-+$/g, '');      // Remove leading/trailing dashes

  if (window.location.hash == '#' + sanitizedHash) {
    document.querySelectorAll('.section-education-content').forEach((content, contentIndex) => {
      content.style.display = 'none';
      if (contentIndex == linkIndex) {
        content.style.display = 'block';
      }
    });
  }
    
  link.addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelectorAll('.section-education-content').forEach((content, contentIndex) => {
      content.style.display = 'none';
      if (contentIndex == linkIndex) {
        content.style.display = 'block';
        window.location.hash = sanitizedHash;

        // Scroll to show content below sticky header
        const siteHeader = document.querySelector('.section-header');
        const siteHeaderHeight = siteHeader ? siteHeader.getBoundingClientRect().height : 60;
        const iconBoxHeight = document.querySelector('.section-education-header .box-shadow.icons')?.offsetHeight || 200;
        const scrollTarget = content.offsetTop - siteHeaderHeight - iconBoxHeight - 20;
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
      }
    });
  });
});

document.addEventListener("click", (e) => {
  const facet = document.getElementById("FacetSortDrawerForm");
  if (e.target.matches("label[for=SortBy]")) {
    const options = document.querySelector("#FacetSortDrawerForm .options");
    options.style.display = options.style.display === "block" ? "none" : "block";
  } else if (e.target.matches("#FacetSortDrawerForm .options div")) {
    const realSelect = document.getElementById("SortBy");
    const options = document.querySelector("#FacetSortDrawerForm .options");
    const value = e.target.getAttribute("data-value");
    // selected.textContent = option.textContent;
    realSelect.value = value;
    const event = new Event("input", { bubbles: true });
    realSelect.dispatchEvent(event);

    options.style.display = "none";
  } else if (facet && !facet.contains(e.target)) {
    const options = document.querySelector("#FacetSortDrawerForm .options");
    options.style.display = "none";
  }
});

// Education Header: Sticky positioning + Mobile slider drag
(function() {
  const educationHeader = document.querySelector('.section-education-header');
  const iconBox = educationHeader?.querySelector('.box-shadow.icons .box');

  if (!educationHeader || !iconBox) return;

  // Calculate and set sticky top position
  function updateStickyPosition() {
    const siteHeader = document.querySelector('.section-header');
    if (!siteHeader) return;

    const siteHeaderHeight = siteHeader.getBoundingClientRect().height;
    const educationHeaderTop = educationHeader.getBoundingClientRect().top + window.scrollY;
    const iconBoxTop = iconBox.getBoundingClientRect().top + window.scrollY;
    const iconBoxOffsetFromEducationTop = iconBoxTop - educationHeaderTop;

    // Sticky top = header height - icon box offset + buffer
    const stickyTop = siteHeaderHeight - iconBoxOffsetFromEducationTop + 10;
    educationHeader.style.setProperty('--education-header-sticky-top', `${Math.round(stickyTop)}px`);
  }

  // Initial calculation
  updateStickyPosition();

  // Recalculate on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateStickyPosition, 100);
  });

  // Mobile slider drag functionality
  let isDown = false;
  let startX;
  let scrollLeft;

  iconBox.addEventListener('mousedown', (e) => {
    isDown = true;
    iconBox.style.cursor = 'grabbing';
    startX = e.pageX - iconBox.offsetLeft;
    scrollLeft = iconBox.scrollLeft;
  });

  iconBox.addEventListener('mouseleave', () => {
    isDown = false;
    iconBox.style.cursor = '';
  });

  iconBox.addEventListener('mouseup', () => {
    isDown = false;
    iconBox.style.cursor = '';
  });

  iconBox.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - iconBox.offsetLeft;
    const walk = (x - startX) * 2;
    iconBox.scrollLeft = scrollLeft - walk;
  });

  // Touch events for mobile
  iconBox.addEventListener('touchstart', (e) => {
    startX = e.touches[0].pageX - iconBox.offsetLeft;
    scrollLeft = iconBox.scrollLeft;
  }, { passive: true });

  iconBox.addEventListener('touchmove', (e) => {
    const x = e.touches[0].pageX - iconBox.offsetLeft;
    const walk = (x - startX) * 2;
    iconBox.scrollLeft = scrollLeft - walk;
  }, { passive: true });
})();